import { CommonModule } from '@angular/common';
import { NgModule, InjectionToken, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LostCredentialsPage } from '@mnz-modules/login//pages/lost-credentials/lost-credentials.page';
import { CustomerRequirementsComponent } from '@mnz-modules/login/containers/customer-requirements/customer-requirements.component';
import { LoginFormComponent } from '@mnz-modules/login/containers/login-form/login-form.component';
import { AuthPage } from '@mnz-modules/login/pages/auth/auth.page';
import { ChooseAccountPage } from '@mnz-modules/login/pages/choose-account/choose-account.page';
import { ActivateAccountPage } from '@mnz-modules/login/pages/activate-account/activate-account.page';
import { AccountEffects } from '@mnz-modules/login/store/effects/account.effects';
import { AuthEffects } from '@mnz-modules/login/store/effects/auth.effects';
import * as fromAccount from '@mnz-modules/login/store/reducers/account.reducer';
import * as fromAuth from '@mnz-modules/login/store/reducers/auth.reducer';
import { SharedModule } from '@mnz-shared/shared.module';
import { EffectsModule } from '@ngrx/effects';
import { ActionReducerMap, StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { IAuthState } from '@mnz-modules/login/store/reducers/auth.reducer';
import { IAccountState } from '@mnz-modules/login/store/reducers/account.reducer';
import { LoginTileComponent } from './containers/login-tile/login-tile.component';
import { LoginHeaderComponent } from './containers/login-header/login-header.component';
import { NesInputDirective } from '@mnz-shared/directives/nes-input.directive';
import { LogoutPage } from '@mnz-modules/login/pages/logout/logout.page';
import { NesCheckboxDirective } from '@mnz-shared/directives/nes-checkbox.directive';
import { NO_ERRORS_SCHEMA } from '@angular/core';
import { SamlPage } from '@mnz-modules/login/pages/saml/saml.page';

export const LOGIN_REDUCERS = new InjectionToken<
  ActionReducerMap<{
    auth: IAuthState;
    account: IAccountState;
  }>
>('Login Reducers');

export function reducerFactory(): ActionReducerMap<{ auth: IAuthState; account: IAccountState }> {
  return {
    auth: fromAuth.reducer,
    account: fromAccount.reducer,
  };
}

const pages = [ChooseAccountPage, AuthPage, LostCredentialsPage, ActivateAccountPage, LogoutPage, SamlPage];
const containers = [LoginFormComponent, CustomerRequirementsComponent, LoginTileComponent, LoginHeaderComponent];

@NgModule({
  declarations: [...pages, ...containers, NesInputDirective, NesCheckboxDirective],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    StoreModule.forFeature('login', LOGIN_REDUCERS),
    EffectsModule.forFeature([AuthEffects, AccountEffects]),
    TranslateModule.forChild(),
    SharedModule,
  ],
  providers: [
    {
      provide: LOGIN_REDUCERS,
      useFactory: reducerFactory,
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class LoginModule {}
